import Vue from 'vue'
import App from './App'
import router from './router'
import QrcodeVue from 'qrcode.vue';

// Firebase Congifuration
// import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import moment from "moment";

// Vue.use(VueFire)

firebase.initializeApp({
    apiKey: "AIzaSyA-9kHXZpRSuIlO_JM2OrYQHTP0qpAQbdg",
    authDomain: "visity-usa.firebaseapp.com",
    databaseURL: "https://visity-usa.firebaseio.com",
    projectId: "visity-usa",
    storageBucket: "visity-usa.appspot.com",
    messagingSenderId: "405206401448",
    appId: "1:405206401448:web:8a78422a9c92a5650d1d9d",
    measurementId: "G-T32CJXZXL4"
})

export const db = firebase.firestore()
// export const storage = firebase.storage()
// End of Firebase Congifuration

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD-MMM-YYYY");
  }
});

Vue.filter("Birthdate", function(value) {
  if (value) {
    return moment(String(value)).format("DD-MMM-YYYY");
  }
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js